import { Globe, Lock, Users } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const KINDS = {
  family: [Users, "Family can see this"],
  guest: [Globe, "Family and guests can see this"],
  admin: [Lock, "Admins only"],
};

// lock = Private/Admin only, people = Family, globe = Guest
export const VisibilityIcon = ({ space, size = 12, className = "", testid }) => {
  const { user } = useAuth();
  const [Icon, label] = KINDS[space] || [Lock, "Only you"];
  return (
    <span className={`vis-icon ${className}`} title={user?.role === "admin" ? label : undefined} aria-label={label} data-testid={testid}>
      <Icon size={size} />
    </span>
  );
};

export const visibilityOf = (spaces = []) => (spaces.includes("guest") ? "guest" : spaces.includes("family") ? "family" : spaces[0]);

export const VisibilityPicker = ({ value, onChange, testid = "visibility-picker" }) => {
  const opts = [["private", "Private"], ["family", "Family"], ["guest", "Both"]];
  return (
    <div className="dest-switch" data-testid={testid}>
      {opts.map(([k, l]) => (
        <button type="button" key={k} className={value === k ? "on" : ""} onClick={() => onChange(k)} data-testid={`${testid}-${k}`}>{l}</button>
      ))}
    </div>
  );
};
